import {req, source, url} from './base'

const Version = '2021-04-21';
const Service = 'iam'

export const GetAccountProjectList = req.wrap({
    url,
    params: {
        Action: 'GetAccountProjectList',
        Version: '2015-11-01',
        source,
        Service
    }
})

